(() => {
  if (window.ffCollectionPageInitialized) return;
  window.ffCollectionPageInitialized = true;
  const mobile = window.matchMedia('(max-width: 999px)');
  const setFilters = () => document.querySelectorAll('[data-ffc-filters]').forEach((details) => { details.open = !mobile.matches; });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ffc-sort]');
    if (select?.form) select.form.requestSubmit();
  });
  document.addEventListener('shopify:section:load', setFilters);
  mobile.addEventListener('change', setFilters);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setFilters, { once: true });
  else setFilters();
})();
